import { MonitorPlay, RefreshCw, Tv, Zap } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { POSTERS } from "../constants/site";

const cardBase =
    "group rounded-3xl border border-[#222232] bg-[#0E0E14] p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-[#E50914]/50 hover:shadow-[0_0_45px_rgba(229,9,20,0.14)] md:p-8";

const iconBox =
    "grid h-12 w-12 place-items-center rounded-2xl border border-[#E50914]/20 bg-[#E50914]/10 text-[#FF4757] transition-colors duration-300 group-hover:bg-[#E50914] group-hover:text-white";

const devices = [
    "Smart TV",
    "Android TV",
    "Fire TV",
    "TV Box",
    "Celular",
    "Tablet",
    "PC",
];

const novidades = [POSTERS.johnwick, POSTERS.topgun, POSTERS.round6];

export const Benefits = () => (
    <section id="beneficios" className="py-20 md:py-28" data-testid="benefits-section">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
            <Reveal className="max-w-2xl">
                <Eyebrow>Por que a Drax?</Eyebrow>
                <h2 className="mt-5 text-3xl font-bold text-white sm:text-4xl">
                    Feita para o seu filme nunca travar na melhor cena.
                </h2>
                <p className="mt-4 text-base leading-relaxed text-[#94A3B8] md:text-lg">
                    Estrutura de servidores dedicada, catálogo atualizado todo
                    dia e suporte de verdade no WhatsApp. É a experiência
                    completa de cinema em casa.
                </p>
            </Reveal>

            <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-12">
                <Reveal className="md:col-span-8" delay={0}>
                    <div className={`${cardBase} h-full`}>
                        <div className={iconBox}>
                            <Zap className="h-6 w-6" />
                        </div>
                        <h3 className="mt-5 text-xl font-bold text-white md:text-2xl">
                            Tecnologia anti-travamento
                        </h3>
                        <p className="mt-2.5 leading-relaxed text-[#94A3B8]">
                            Servidores dedicados com balanceamento automático
                            para garantir a transmissão contínua até nos jogos
                            de maior audiência do país.
                        </p>
                        <div className="mt-6 flex flex-wrap gap-2">
                            {devices.map((d) => (
                                <span
                                    key={d}
                                    className="rounded-full border border-[#222232] bg-[#14141E] px-3.5 py-1.5 text-xs font-bold text-[#94A3B8]"
                                >
                                    {d}
                                </span>
                            ))}
                        </div>
                    </div>
                </Reveal>

                <Reveal className="md:col-span-4" delay={0.08}>
                    <div className={`${cardBase} h-full`}>
                        <div className={iconBox}>
                            <MonitorPlay className="h-6 w-6" />
                        </div>
                        <h3 className="mt-5 text-xl font-bold text-white md:text-2xl">
                            Qualidade 4K Ultra HD
                        </h3>
                        <p className="mt-2.5 leading-relaxed text-[#94A3B8]">
                            Imagem cristalina com áudio imersivo para uma
                            experiência de cinema direto na sua sala.
                        </p>
                    </div>
                </Reveal>

                <Reveal className="md:col-span-4" delay={0}>
                    <div className={`${cardBase} h-full`}>
                        <div className={iconBox}>
                            <Tv className="h-6 w-6" />
                        </div>
                        <h3 className="mt-5 text-xl font-bold text-white md:text-2xl">
                            Compatibilidade total
                        </h3>
                        <p className="mt-2.5 leading-relaxed text-[#94A3B8]">
                            Funciona em praticamente qualquer tela que você
                            tiver em casa, com configuração guiada por nós.
                        </p>
                    </div>
                </Reveal>

                <Reveal className="md:col-span-8" delay={0.08}>
                    <div className={`${cardBase} h-full`}>
                        <div className={iconBox}>
                            <RefreshCw className="h-6 w-6" />
                        </div>
                        <h3 className="mt-5 text-xl font-bold text-white md:text-2xl">
                            Lançamentos novos todo dia
                        </h3>
                        <p className="mt-2.5 leading-relaxed text-[#94A3B8]">
                            Novos episódios de séries e estreias do cinema
                            adicionados automaticamente — você nunca fica para
                            trás no que todo mundo está assistindo.
                        </p>
                        <div className="mt-6 flex items-center gap-3">
                            {novidades.map((src, i) => (
                                <img
                                    key={i}
                                    src={src}
                                    alt="Lançamento disponível na Drax Filmes"
                                    loading="lazy"
                                    className="aspect-[2/3] h-20 rounded-lg border border-[#222232] object-cover"
                                />
                            ))}
                            <span className="rounded-full border border-[#E50914]/30 bg-[#E50914]/10 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wider text-[#FF4757]">
                                + novo hoje
                            </span>
                        </div>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
